import { Box, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Control, useFormContext, useWatch } from 'react-hook-form';
import AppTextField from './AppTextField';

interface Props {
	control: Control<any>;
	label: string;
}

/**
 * Age of Appendix 4–7 (CHA-009). Shows "(Estimated)" at the end while the
 * prefilled age comes from the member's estimate (`ageEstimated`); typing in
 * the field clears the marker. Must be inside a `FormProvider`.
 */
export default function AppEstimatedAgeTextField({ control, label }: Props) {
	const { t } = useTranslation();
	const { setValue } = useFormContext();
	const ageEstimated = useWatch({ control, name: 'ageEstimated' });

	return (
		<Box
			onChange={() => {
				if (ageEstimated) setValue('ageEstimated', false);
			}}
		>
			<AppTextField
				control={control}
				name='age'
				label={label}
				InputProps={
					ageEstimated
						? {
								endAdornment: (
									<InputAdornment position='end'>
										{t('memberAge.estimated')}
									</InputAdornment>
								),
							}
						: undefined
				}
			/>
		</Box>
	);
}
